(() => {
  if (window.wpcNewsletterShieldInstalled) return;
  window.wpcNewsletterShieldInstalled = true;
  let apiPromise;
  const states = new WeakMap();
  const selector = 'form[data-wpc-newsletter-shield]';
  const loadApi = () => {
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (apiPromise) return apiPromise;
    apiPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timer = setTimeout(() => reject(new Error('verification_unavailable')), 15000);
      window.wpcNewsletterTurnstileReady = () => { clearTimeout(timer); resolve(window.turnstile); };
      script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=wpcNewsletterTurnstileReady';
      script.async = true;
      script.onerror = () => { clearTimeout(timer); script.remove(); apiPromise = null; reject(new Error('verification_unavailable')); };
      document.head.appendChild(script);
    });
    apiPromise.catch(() => { apiPromise = null; });
    return apiPromise;
  };
  const stateFor = form => {
    if (states.has(form)) return states.get(form);
    const status = form.querySelector('[data-shield-status]');
    const state = { busy: false, status, widget: null };
    states.set(form, state);
    return state;
  };
  const tokenFor = async (form, state) => {
    const api = await loadApi();
    if (state.widget !== null) { api.remove(state.widget); state.widget = null; }
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => reject(new Error('verification')), 45000);
      const fail = () => { clearTimeout(timer); reject(new Error('verification')); };
      state.widget = api.render(form.querySelector('[data-shield-widget]'), {
        sitekey: form.dataset.shieldSitekey,
        action: 'newsletter',
        appearance: 'always',
        execution: 'execute',
        size: 'flexible',
        'response-field': false,
        callback: token => { clearTimeout(timer); resolve(token); },
        'error-callback': fail,
        'expired-callback': fail,
        'timeout-callback': fail
      });
      api.execute(state.widget);
    });
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches(selector)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const state = stateFor(form);
    if (state.busy || !form.reportValidity()) return;
    state.busy = true;
    const buttons = Array.from(form.querySelectorAll('[type="submit"]'));
    buttons.forEach(button => { button.disabled = true; });
    state.status.hidden = false;
    state.status.textContent = form.dataset.shieldChecking;
    form.setAttribute('aria-busy', 'true');
    try {
      const token = await tokenFor(form, state);
      const body = new URLSearchParams(new FormData(form));
      body.set('cf-turnstile-response', token);
      const response = await fetch(form.action, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        credentials: 'omit',
        body: body.toString(),
        signal: AbortSignal.timeout(30000)
      });
      const result = await response.json();
      if (!response.ok || !result.ok) throw new Error(result.code || 'unavailable');
      if (result.redirect !== 'https://whirlpool-center.de/pages/danke-erfolgreich') throw new Error('unavailable');
      window.location.assign(result.redirect);
    } catch (error) {
      const code = error.message;
      state.status.textContent = code === 'rate_limited' ? form.dataset.shieldLimited :
        code === 'delivery_uncertain' ? form.dataset.shieldUncertain : form.dataset.shieldError;
      state.status.setAttribute('tabindex', '-1');
      state.status.focus();
      if (state.widget !== null && window.turnstile) { window.turnstile.remove(state.widget); state.widget = null; }
      buttons.forEach(button => { button.disabled = false; });
      state.busy = false;
      form.removeAttribute('aria-busy');
    }
  }, true);
})();
